import { render, staticRenderFns } from "./DependencyDetail.vue?vue&type=template&id=0f85739a&scoped=true&"
import script from "./DependencyDetail.vue?vue&type=script&lang=js&"
export * from "./DependencyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f85739a",
  null
  
)

export default component.exports